import { render } from "./CreateContact.vue?vue&type=template&id=4df3bed1&scoped=true"
import script from "./CreateContact.vue?vue&type=script&lang=js"
export * from "./CreateContact.vue?vue&type=script&lang=js"

import "./CreateContact.vue?vue&type=style&index=0&id=4df3bed1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df3bed1"]])

export default __exports__